import { render, staticRenderFns } from "./FigmaTextLayer.vue?vue&type=template&id=78d184cb&scoped=true"
import script from "./FigmaTextLayer.vue?vue&type=script&lang=js"
export * from "./FigmaTextLayer.vue?vue&type=script&lang=js"
import style0 from "./FigmaTextLayer.vue?vue&type=style&index=0&id=78d184cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d184cb",
  null
  
)

export default component.exports